import {
  put, takeLatest, all, takeEvery, select,
} from 'redux-saga/effects';
import TrackerActions from '@Actions/trackerActions';
import { notification } from 'antd';
import ShopifyIntegrationActions, { shopifyIntegrationActionTypes } from '../../actions/integrations/shopifyIntegrationActions';
import ShopifyIntegrationServices from '../../services/integrations/shopifyIntegrationServices';

/**
 * @param action
 */
function* _connectToShopify(action) {
  try {
    const { orgId, callback } = action;
    yield put(ShopifyIntegrationActions.connectToShopifyLoading(true));
    const connectToShopifyData = yield ShopifyIntegrationServices.connectToShopify(orgId);
    yield put(ShopifyIntegrationActions.connectToShopifySuccess(connectToShopifyData));

    if (connectToShopifyData.result && connectToShopifyData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Connected to Shopify Successfully',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: connectToShopifyData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ShopifyIntegrationActions.connectToShopifyLoading(false));
  } catch (error) {
    yield put(ShopifyIntegrationActions.connectToShopifyLoading(false));
    yield put(TrackerActions.trackAction(shopifyIntegrationActionTypes.CONNECT_TO_SHOPIFY.ERROR, error));
  }
}
/**
 *
 */
function* connectToShopify() {
  yield takeEvery(shopifyIntegrationActionTypes.CONNECT_TO_SHOPIFY.REQUEST, _connectToShopify);
}

/**
 * @param action
 */
function* _deleteShopifyConnection(action) {
  try {
    const { payload, callback } = action;
    yield put(ShopifyIntegrationActions.deleteShopifyConnectionLoading(true));
    const deleteConnection = yield ShopifyIntegrationServices.deleteShopifyConnection(payload);
    if (deleteConnection.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Shopify Connection Disconnected.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: deleteConnection.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ShopifyIntegrationActions.deleteShopifyConnectionLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ShopifyIntegrationActions.deleteShopifyConnectionLoading(false));
    yield put(TrackerActions.trackAction(shopifyIntegrationActionTypes.DELETE_SHOPIFY_CONNECTION.ERROR, error));
  }
}
/**
 *
 */
function* deleteShopifyConnection() {
  yield takeLatest(shopifyIntegrationActionTypes.DELETE_SHOPIFY_CONNECTION.REQUEST, _deleteShopifyConnection);
}

/**
 * @param action
 */
function* _getShopifyConnections(action) {
  try {
    const {
      orgId, callback,
    } = action;
    yield put(ShopifyIntegrationActions.getShopifyConnectionsLoading(true));
    const linkedShopifyAccounts = yield ShopifyIntegrationServices.getShopifyConnections(orgId);
    yield put(ShopifyIntegrationActions.getShopifyConnectionsSuccess(linkedShopifyAccounts?.result));
    if (linkedShopifyAccounts.success) {
      if (callback) {
        callback(linkedShopifyAccounts.result);
      }
    }
    yield put(ShopifyIntegrationActions.getShopifyConnectionsLoading(false));
  } catch (error) {
    yield put(ShopifyIntegrationActions.getShopifyConnectionsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(shopifyIntegrationActionTypes.GET_SHOPIFY_CONNECTIONS.ERROR, error));
  }
}

/**
 *
 */
function* getShopifyConnections() {
  yield takeLatest(shopifyIntegrationActionTypes.GET_SHOPIFY_CONNECTIONS.REQUEST, _getShopifyConnections);
}

/**
 * @param action
 */
function* _connectTenantToShopifyLocation(action) {
  try {
    const { payload, callback } = action;
    yield put(ShopifyIntegrationActions.connectTenantToShopifyLocationLoading(true));
    const connectToShopifyData = yield ShopifyIntegrationServices.connectTenantToShopifyLocation(payload);
    if (connectToShopifyData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: connectToShopifyData?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: connectToShopifyData?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ShopifyIntegrationActions.connectTenantToShopifyLocationLoading(false));
  } catch (error) {
    yield put(ShopifyIntegrationActions.connectTenantToShopifyLocationLoading(false));
    yield put(TrackerActions.trackAction(shopifyIntegrationActionTypes.CONNECT_TENANT_TO_SHOPIFY_LOCATION.ERROR, error));
  }
}
/**
 *
 */
function* connectTenantToShopifyLocation() {
  yield takeLatest(shopifyIntegrationActionTypes.CONNECT_TENANT_TO_SHOPIFY_LOCATION.REQUEST, _connectTenantToShopifyLocation);
}

/**
 * @param action
 */
function* _updateShopifyConfiguration(action) {
  try {
    const { payload, callback } = action;
    yield put(ShopifyIntegrationActions.updateShopifyConfigurationLoading(true));
    const updateShopifyConfigurationData = yield ShopifyIntegrationServices.updateShopifyConfiguration(payload);
    if (updateShopifyConfigurationData.success) {
      notification.open({
        type: 'success',
        message: 'We have successfully updated your configurations.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: updateShopifyConfigurationData.error,
        duration: 4,
        placement: 'top',
      });
    }
    if (callback) {
      callback();
    }
    yield put(ShopifyIntegrationActions.updateShopifyConfigurationLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ShopifyIntegrationActions.updateShopifyConfigurationLoading(false));
    yield put(TrackerActions.trackAction(shopifyIntegrationActionTypes.UPDATE_SHOPIFY_CONFIGURATION.ERROR, error));
  }
}
/**
 *
 */
function* updateShopifyConfiguration() {
  yield takeLatest(shopifyIntegrationActionTypes.UPDATE_SHOPIFY_CONFIGURATION.REQUEST, _updateShopifyConfiguration);
}

/**
 * @param action
 */
function* _syncShopifyInventory(action) {
  try {
    const { payload, callback } = action;
    yield put(ShopifyIntegrationActions.syncShopifyInventoryLoading(true));
    const syncVendorData = yield ShopifyIntegrationServices.syncShopifyInventory(payload);
    if (syncVendorData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Shopify Inventory synced successfully with Shopify.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: syncVendorData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ShopifyIntegrationActions.syncShopifyInventoryLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ShopifyIntegrationActions.syncShopifyInventoryLoading(false));
    yield put(TrackerActions.trackAction(shopifyIntegrationActionTypes.SYNC_SHOPIFY_INVENTORY.ERROR, error));
  }
}
/**
 *
 */
function* syncShopifyInventory() {
  yield takeLatest(shopifyIntegrationActionTypes.SYNC_SHOPIFY_INVENTORY.REQUEST, _syncShopifyInventory);
}

/**
 * @param action
 */
function* _syncShopifyCustomer(action) {
  try {
    const { payload, callback } = action;
    yield put(ShopifyIntegrationActions.syncShopifyCustomerLoading(true));
    const syncShopifyCustomerData = yield ShopifyIntegrationServices.syncShopifyCustomer(payload);
    if (syncShopifyCustomerData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Vendor synced successfully with Shopify .',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: syncShopifyCustomerData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ShopifyIntegrationActions.syncShopifyCustomerLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ShopifyIntegrationActions.syncShopifyCustomerLoading(false));
    yield put(TrackerActions.trackAction(shopifyIntegrationActionTypes.SYNC_SHOPIFY_CUSTOMER.ERROR, error));
  }
}
/**
 *
 */
function* syncShopifyCustomer() {
  yield takeLatest(shopifyIntegrationActionTypes.SYNC_SHOPIFY_CUSTOMER.REQUEST, _syncShopifyCustomer);
}

/**
 * @param action
 */
function* _syncShopifySO(action) {
  try {
    const { payload, callback } = action;
    const state = yield select();
    const { user } = state?.UserReducers;
    const salesOrderUIName = user?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings?.ui_name || 'Sales Order';
    yield put(ShopifyIntegrationActions.syncShopifySOLoading(true));
    const syncShopifySOData = yield ShopifyIntegrationServices.syncShopifySO(payload);
    if (syncShopifySOData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: `${salesOrderUIName} synced successfully with Shopify.`,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: syncShopifySOData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ShopifyIntegrationActions.syncShopifySOLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ShopifyIntegrationActions.syncShopifySOLoading(false));
    yield put(TrackerActions.trackAction(shopifyIntegrationActionTypes.SYNC_SHOPIFY_SO.ERROR, error));
  }
}
/**
 *
 */
function* syncShopifySO() {
  yield takeLatest(shopifyIntegrationActionTypes.SYNC_SHOPIFY_SO.REQUEST, _syncShopifySO);
}

/**
 * @param action
 */
function* _syncShopifyOrders(action) {
  try {
    const { payload, callback } = action;
    yield put(ShopifyIntegrationActions.syncShopifyOrdersLoading(true));
    const syncShopifyOrdersData = yield ShopifyIntegrationServices.syncShopifyOrders(payload);
    if (syncShopifyOrdersData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Orders synced successfully with Shopify.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: syncShopifyOrdersData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ShopifyIntegrationActions.syncShopifyOrdersLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ShopifyIntegrationActions.syncShopifyOrdersLoading(false));
    yield put(TrackerActions.trackAction(shopifyIntegrationActionTypes.SYNC_SHOPIFY_ORDERS.ERROR, error));
  }
}
/**
 *
 */
function* syncShopifyOrders() {
  yield takeLatest(shopifyIntegrationActionTypes.SYNC_SHOPIFY_ORDERS.REQUEST, _syncShopifyOrders);
}

/**
 * @param action
 */
function* _cancelShopifyOrder(action) {
  try {
    yield put(ShopifyIntegrationActions.cancelShopifyOrderLoading(true));
    const so = yield ShopifyIntegrationServices.cancelShopifyOrder(action.payload);
    if (so.success) {
      notification.open({
        type: 'success',
        message: 'Order successfully cancelled',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ShopifyIntegrationActions.cancelShopifyOrderLoading(false));
  } catch (error) {
    yield put(ShopifyIntegrationActions.cancelShopifyOrderLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(shopifyIntegrationActionTypes.CANCEL_SHOPIFY_ORDER.ERROR, error));
  }
}

/**
 *
 */
function* cancelShopifyOrder() {
  yield takeLatest(shopifyIntegrationActionTypes.CANCEL_SHOPIFY_ORDER.REQUEST, _cancelShopifyOrder);
}

/**
 * @param action
 */
function* _createADHOC(action) {
  try {
    yield put(ShopifyIntegrationActions.createADHOCLoading(true));
    const so = yield ShopifyIntegrationServices.createADHOC(action.payload);
    if (so.success) {
      notification.open({
        type: 'success',
        message: 'Product added successfully',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ShopifyIntegrationActions.createADHOCLoading(false));
  } catch (error) {
    yield put(ShopifyIntegrationActions.createADHOCLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(shopifyIntegrationActionTypes.CREATE_ADHOC.ERROR, error));
  }
}

/**
 *
 */
function* createADHOC() {
  yield takeLatest(shopifyIntegrationActionTypes.CREATE_ADHOC.REQUEST, _createADHOC);
}

/**
 *
 */
export default function* shopifyIntegrationSaga() {
  yield all([
    getShopifyConnections(),
    connectToShopify(),
    deleteShopifyConnection(),
    connectTenantToShopifyLocation(),
    updateShopifyConfiguration(),
    syncShopifyInventory(),
    syncShopifyCustomer(),
    syncShopifySO(),
    syncShopifyOrders(),
    cancelShopifyOrder(),
    createADHOC(),
  ]);
}
